/* unplugin-vue-components disabled */import { render } from "./WorkflowRejectedBlock.vue?vue&type=template&id=4b5d36c2&scoped=true&ts=true"
import script from "./WorkflowRejectedBlock.vue?vue&type=script&lang=ts"
export * from "./WorkflowRejectedBlock.vue?vue&type=script&lang=ts"

import "./WorkflowRejectedBlock.vue?vue&type=style&index=0&id=4b5d36c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5d36c2"]])

export default __exports__